<template>
	<c-dialog ref="dialog" height="560" width="600" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<!--来源信息-->
			<div class="ref-info-bar" v-if="refData.ref_type">
				<span class="ref-label">关联协同</span>
				<span class="ref-type-name">{{refTypeName}}</span>
				<span class="ref-code-label">单号</span>
				<span class="ref-code">{{refData.ref_code || '-'}}</span>
			</div>
			<c-form-item label="任务类型" required>
				<c-select name="task_type_id" :options="typeOptions" :clear="false" @change="changeType"></c-select>
			</c-form-item>
			<c-form-item label="负责人" required>
				<c-select ref="user" name="user_id" async @search="searchScopeUser" :value-data="selectedUser" @change="changeUser"></c-select>
			</c-form-item>
			<c-form-item label="任务标题" required>
				<c-input name="task_title" maxlength="100" @change="touchTitle"></c-input>
			</c-form-item>
			<c-form-item label="任务描述">
				<c-input name="task_desc" type="textarea" maxlength="500" rows="4"></c-input>
			</c-form-item>
			<c-form-item label="附件">
				<c-upload-file name="attachment_files" v-model="attachmentFiles" multiple="9"></c-upload-file>
			</c-form-item>
			<!--自定义字段控件-->
			<custom-form ref="customForm" work-type="51"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'collabTaskEdit',

		data() {
			return {
				typeOptions: [],
				selectedUser: [],
				attachmentFiles: [],
				refData: {}
			}
		},

		computed: {
			...mapState(['userInfo']),
			refTypeName() {
				if (!this.refData.ref_type) return '';
				switch (this.refData.ref_type.toString()) {
				case '3': return '生产工单';
				case '13': return '生产任务';
				default: return '来源';
				}
			}
		},

		methods: {
			/*********打开编辑框，初始化**********/
			//data 编辑时传列表行数据；发起协同时传 {ref_type, ref_id, ref_code}
			open(data) {
				this._editState = !!(data && data.id);
				this._titleTouched = false;
				this._autoTitle = '';
				this._typeList = [];
				this._userName = '';
				this.selectedUser = [];
				this.attachmentFiles = [];
				this.refData = data && !data.id ? data : {};

				this.$refs.form.clear();
				this.$refs.customForm.init();

				//加载任务类型选项
				this.loadTypeOptions();

				if (this._editState) {
					//查询协同任务详情
					this.request({
						url: '/collab/task/detail',
						data: {
							id: data.id
						},
						success: data => {
							this.refData = {
								ref_type: data.ref_type,
								ref_id: data.ref_id,
								ref_code: data.ref_code || ''
							};
							this.$refs.form.set(data);
							//负责人回显
							if (data.user_id) {
								this._userName = data.user_realname;
								this.selectedUser = [{
									name: data.user_realname,
									value: data.user_id
								}];
							}
							//附件回显
							if (data.attachment_json) {
								try {
									this.attachmentFiles = data.attachment_json || [];
								} catch (e) {}
							}
						}
					});
				}
				//填充form表单
				this.$refs.dialog.open({
					title: this._editState ? '编辑协同任务' : '创建协同任务'
				});
			},

			/*******加载任务类型选项*****************/
			loadTypeOptions() {
				this.request({
					url: '/collab/task/type/list',
					data: {},
					success: data => {
						this._typeList = data || [];
						this.typeOptions = this._typeList.map(item => {
							return {
								name: item.type_name,
								value: item.id
							}
						});
					}
				});
			},

			/*******任务类型变更：填充默认负责人 + 生成标题*****************/
			//c-select change 参数为选中项 {name, value}
			changeType(option) {
				if (!option || !option.value) return;
				let type = (this._typeList || []).find(item => item.id == option.value) || {};
				if (type.default_user_id && (!this._editState || !this.$refs.form.get().user_id)) {
					//新建时选择/切换类型自动带入默认负责人；编辑时仅负责人为空才填充
					this._userName = type.default_user_realname;
					this.selectedUser = [{
						name: type.default_user_realname,
						value: type.default_user_id
					}];
					this.$refs.form.set({user_id: type.default_user_id});
				}
				this.generateTitle();
			},

			/*******负责人变更：更新标题*****************/
			changeUser(option) {
				this._userName = option && option.name ? option.name : '';
				this.generateTitle();
			},

			/*******用户手动修改过标题后不再自动覆盖*****************/
			//c-input change 在失焦时触发，与最后一次自动生成值相同则不算手改
			touchTitle(val) {
				if (val !== this._autoTitle) {
					this._titleTouched = true;
				}
			},

			/*******按任务类型标题规则自动生成任务标题*****************/
			generateTitle() {
				//编辑态、用户手改过标题时不覆盖
				if (this._editState || this._titleTouched) return;

				let formData = this.$refs.form.get();
				let type = (this._typeList || []).find(item => item.id == formData.task_type_id);
				if (!type || !type.title_rule) return;

				let codes = [];
				try {
					codes = type.title_rule || [];
				} catch (e) {}
				if (!codes.length) return;

				let now = new Date();
				let dateText = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2);
				let parts = codes.map(code => {
					switch (code) {
					case 'type_name':
						return type.type_name;
					case 'user_realname':
						return this._userName;
					case 'create_user_realname':
						return this.userInfo.user_realname;
					case 'create_date':
						return dateText;
					default:
						return '';
					}
				}).filter(item => item);

				if (parts.length) {
					this._autoTitle = parts.join('-');
					this.$refs.form.set({task_title: this._autoTitle});
				}
			},

			/*******搜索负责人（限任务类型的负责人范围内）*****************/
			searchScopeUser(keyword, resolve){
				this.request({
					url: '/collab/task/type/scope/users',
					data: {
						keyword: keyword,
						task_type_id: this.$refs.form.get().task_type_id || ''
					},
					success: data => {
						resolve(data);
					}
				})
			},

			/*******创建、编辑提交处理方法********/
			editHandle (stop, next){
				stop();
				this.$refs.form.submit({
					url: this._editState ? '/collab/task/edit' : '/collab/task/add',
					rule: {
						task_type_id: '请选择任务类型',
						user_id: '请选择负责人',
						task_title: '请输入任务标题',
						...this.$refs.customForm.rule
					},
					dataFormatter: data => {
						data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
						//附件（JSON数组存储）
						let files = data.attachment_files || [];
						data.attachment_json = files.length ? JSON.stringify(files) : '';
						delete data.attachment_files;
						//关联单据（发起协同场景）
						if (this.refData.ref_type) {
							data.ref_type = this.refData.ref_type;
							data.ref_id = this.refData.ref_id;
						}
						return data;
					},
					success: (data, res) => {
						next();
						this.$message({
							message: this._editState ? '编辑协同任务成功' : '协同任务发起成功',  // 提示内容,
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.ref-info-bar {
		display: flex;
		align-items: center;
		padding: 10px 14px;
		margin-bottom: 12px;
		background: #f4f4f5;
		border-radius: 4px;

		.ref-label {
			display: inline-block;
			padding: 2px 8px;
			background: #409EFF;
			color: #fff;
			font-size: 12px;
			line-height: 1.5;
			border-radius: 3px;
			margin-right: 10px;
		}

		.ref-type-name {
			font-size: 14px;
			color: #303133;
			margin-right: 10px;
		}

		.ref-code-label {
			font-size: 12px;
			color: #909399;
			margin-right: 4px;
		}

		.ref-code {
			font-size: 14px;
			color: #409EFF;
		}
	}
</style>
